import React, {useEffect, useLayoutEffect, useRef, useState} from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { FileUpload } from "../../Shared/FileUpload";
import Button from "@mui/material/Button";
import Popout from "react-popout";
import PropTypes from "prop-types";
import ComparableGrid from "components/Homeowner/CaseForms/ComparableGrid/ComparableGrid";
import AppInsightsTracker from "components/Shared/AppInsightsTracker";
import {MSpinner} from "components/Shared";
import {generateSsoParameters} from "requests/collateralAnalytics";
import {
  setupSignalRConnection,
  SignalRConnectionStatus_Connected,
  SignalRConnectionStatus_Connecting,
  SignalRConnectionStatus_Disconnected,
  SignalRConnectionStatus_Reconnecting
} from "middlewares/signalrAspNet";
import WebConfig from "middlewares/WebConfig";
import {connect} from "react-redux";
import {Phonelink, PhonelinkOff, Router, DeviceUnknown, CloudDownload, CheckBoxOutlineBlank} from "@mui/icons-material";
import {getPropmixSso} from "requests/comparables";

// Button and other text for this Component
const PrimarySearchButtonText = "Primary Search";
const SecondarySearchButtonText = "Secondary Search";

const AfterPropmixClosed = "Refreshing Comparable grid after Propmix...";
const PropmixStartupText = "Starting Propmix";
const PropmixOpenText = "Propmix Is Open";

const CollateralAnalyticsSsoStartupText = "Starting CollateralAnalytics";
const CollateralAnalyticsSsoOpenText = "CollateralAnalytics Is Open";
const AfterCollateralAnalyticsSsoClosed = "Refreshing Comparable grid after Collateral Analytics...";

const ImportMismoText = "Import MISMO";
const ImportMismoWarning = "NOTE: The Comparable Property import process will overwrite existing data in the comparable grid.";
const ImportMismoQuestion = "Are you sure you want to proceed?";
const ImportMismoToastError = "MISMO import failed. ";
const ImportMismoToastSuccess = "MISMO import success.";
const ImportMismoWorking = "Please wait while the comparable properties are imported.";

const AfterCompGridDataImported = "Refreshing Comparable grid after data import...";

const CompSearch = (
  {
    form,
    formId,
    token,
    allowMismoImport,
    comparable,
    formStatusChange,
    formStatus,
    controlNumber,
    importMismo,
    makeToast,
    onPhotoView,
    onFormSave,
    initSignalR,
    signalrToken,

  }
) => {
  const connectionStatus_NotConnected = 999;
  const SignalRSignalStateIcon = (value) => {
    switch (value) {
      case SignalRConnectionStatus_Connecting:
        return <Router titleAccess={"Connecting"} fontSize={"small"}/>;
      case SignalRConnectionStatus_Connected:
        return <Phonelink titleAccess={"Connected"} fontSize={"small"}/>;
      case SignalRConnectionStatus_Reconnecting:
        return <Router titleAccess={"Reconnecting"} fontSize={"small"}/>;
      case SignalRConnectionStatus_Disconnected:
        return <PhonelinkOff titleAccess={"Disconnected"} fontSize={"small"}/>;
      case connectionStatus_NotConnected:
        return <CheckBoxOutlineBlank titleAccess={"Not Connected"} fontSize={"small"}/>;
    }
    return <DeviceUnknown titleAccess={`Unknown: ${value}`} fontSize={"small"}/>;
  };

  const mounted = useRef(true);
  //const displayName = "CompSearch";
  const timer = useRef(0);
  const caTimer = useRef(0);

  const [confirmIsVisible, confirmIsVisibleSet] = useState(false);
  const [caVisible, caVisibleSet] = useState(false);
  const [propmixVisible, propmixVisibleSet] = useState(false);
  const [propmixSsoUrlData, propmixSsoUrlDataSet] = useState({
    controlNumber: -1,
    propmixSsoUrl: ""
  });
  const [currentlyUploadingFileId, currentlyUploadingFileIdSet] = useState(null);
  const [reloadFrame, reloadFrameSet] = useState(false);
  const [uploading, uploadingSet] = useState(false);
  const [fetchingPropmixSsoUrl, fetchingPropmixSsoUrlSet] = useState(false);
  const [fetchingCollateralAnalyticsSsoParams, fetchingCollateralAnalyticsSsoParamsSet] = useState(false);
  const [collateralAnalyticsSsoVisible, collateralAnalyticsSsoVisibleSet] = useState(false);
  const [currentlyUploadingFile, currentlyUploadingFileSet] = useState(null);
  const [signalRSignalState, signalRSignalStateSet] = useState({
    oldState: SignalRConnectionStatus_Disconnected,
    newState: connectionStatus_NotConnected
  });
  const [collateralAnalyticsSsoIcon, collateralAnalyticsSsoIconSet] = useState(SignalRSignalStateIcon(connectionStatus_NotConnected));
  const signalRStateRef = useRef({
    oldState: SignalRConnectionStatus_Disconnected,
    newState: connectionStatus_NotConnected
  });

  const propMixWindowHandle = useRef(0);

  function windowHandleSet(value) {
    propMixWindowHandle.current = value;
  }

  const caSsoWindowHandle = useRef(0);

  function caSsoWindowHandleSet(value) {
    caSsoWindowHandle.current = value;
  }

  useEffect(() => {
    // check if we need to reload the Frame.
    if (reloadFrame) {
      formStatusChange(form.title, "clean", form.id);
      reloadFrameSet(false);
    } else if (formStatus === "needsRefresh") {
      reloadFrameSet(false);
    }
  }, [reloadFrame]);

  useEffect(() => {
    collateralAnalyticsSsoIconSet(SignalRSignalStateIcon(signalRSignalState.newState));
  }, [signalRSignalState]);

  useEffect(() => {
    // component unmount handling
    return () => {
      if (timer && timer.current) {
        clearInterval(timer.current);
        timer.current = 0;
      }
      if (caTimer && caTimer.current){
        clearInterval(caTimer.current);
        caTimer.current = 0;
      }
      mounted.current = false;
    };
  }, []);

  useLayoutEffect(() => {
    if (reloadFrame) {
      reloadFrameSet(false);
    }
  }, []);

  const onReceiveEventOnCase = (message) => {
    if (!reloadFrame && form &&
      mounted.current &&
      message.ControlNumber == controlNumber &&
      message.Molecule === "Appraisal" &&
      message.ObjectName === "CompGrid"
    ) {
      switch (message.EventType) {
        case "DataImportStarted":
          collateralAnalyticsSsoIconSet(<CloudDownload titleAccess={"Importing"} fontSize={"small"}/>);
          break;
        case "DataImportCompleted":
          collateralAnalyticsSsoIconSet(SignalRSignalStateIcon(signalRStateRef.current.newState));
          reloadFrameSet(true);
          makeToast(AfterCompGridDataImported, "success");
          break;
      }
    }
  };
  const signalrConnectionHub = useRef(null);

  useLayoutEffect(() => {
    return () => {
      // Close PropMix window
      propMixWindowHandle.current && propMixWindowHandle.current.close();
      propMixWindowHandle.current = 0;
      // Close C/A window
      caSsoWindowHandle.current && caSsoWindowHandle.current.close();
      caSsoWindowHandle.current = 0;
      // Disconnect SignalR on component unmount
      const localSignalRHub = signalrConnectionHub.current;
      signalrConnectionHub.current = null;
      localSignalRHub && localSignalRHub.stop(true, true);
    };
  }, []);

  const signalR_ReconnectDelay = useRef(1000);
  const signalRStateChanged = (e, data) => {
    signalRSignalStateSet(data);
    signalRStateRef.current = data;
    if (data.newState === SignalRConnectionStatus_Connected){
      signalR_ReconnectDelay.current = 1000;
    }
    // Re-open the connection if connection is lost while the C/A window is open
    if (signalrConnectionHub.current && caSsoWindowHandle.current && data.newState === SignalRConnectionStatus_Disconnected) {
      window.setTimeout(() => {
        signalrConnectionHub.current.start();
      }, signalR_ReconnectDelay.current);
      signalR_ReconnectDelay.current += 1000;
    }
  };

  function startSignalRConnection() {
    if (signalrConnectionHub.current && signalRStateRef.current.newState === SignalRConnectionStatus_Disconnected) {
      // Reconnect SignalR if the connection is disconnected
      signalrConnectionHub.current = null;
    }
    if (!signalrConnectionHub.current) {
      // Create a new SignalR connection
      let connectionFunc = setupSignalRConnection(
        WebConfig.signalrConnectionRoot, "CaseEventHub",
        {
          ControlNumber: controlNumber
        },
        {
          ReceiveEventOnCase: onReceiveEventOnCase
        },
        () => {
          return signalrToken;
        });
      signalrConnectionHub.current = initSignalR(connectionFunc)
        .then((v) => {
          v.events.onStateChanged.push(signalRStateChanged);
          v.reconnectWindow = Math.max(v.reconnectWindow, 120000); // Try reconnecting for at least 120 seconds
          v.serverTimeoutInMilliseconds = Math.max(v.serverTimeoutInMilliseconds, v.reconnectWindow * 2, 240000); // Try reconnecting for at least 120 seconds
          signalrConnectionHub.current = v;
        });
    }
  }

  // Collateral Analytics - Classic Mueller UI
  // -------------------------------------------------------------------------------------------
  function showCaSearch() {
    caVisibleSet(true);
    formStatusChange(form.title, "openedComps", form.id);
  }

  // This will not get called on ones local machine. Need to be running the site
  // out of the Mueller-inc.com domain.
  function hideCaSearch() {
    formStatusChange(form.title, "closedComps", form.id);
    formStatusChange(form.title, "savedSuccess", form.id);
    formStatusChange(form.title, "clean", form.id);
    caVisibleSet(false);
    reloadFrameSet(true);
  }

  // Propmix.io MCA - Market Conditions Advisor
  // -------------------------------------------------------------------------------------------
  function showPropmix(e) {
    e.preventDefault();
    if (controlNumber === 0) return;
    if ((!propmixSsoUrlDataSet.propmixSsoUrl || !propmixSsoUrlDataSet.success) || propmixSsoUrlDataSet.controlNumber !== controlNumber) {
      fetchingPropmixSsoUrlSet(true);
      getPropmixSso(controlNumber, (data) => {
            fetchingPropmixSsoUrlSet(false);
            if (data.success) {
              showPropmixWindow(data.propmixSsoUrl);
            }
            propmixSsoUrlDataSet(data);
          }
          , mounted);
    } else {
      showPropmixWindow(propmixSsoUrlData.propmixSsoUrl);
    }
  }

  function showPropmixWindow(propmixUrl) {
    let windowFeatures = "width=1300,height=768,scrollbars=yes,resizable=yes,top=100,left=100";
    if (window.innerHeight < 768 && window.innerHeight > 200) {
      windowFeatures = windowFeatures.replace("768", window.innerHeight - 200);
    }
    if (window.innerWidth < 1300 && window.innerWidth > 200) {
      windowFeatures = windowFeatures.replace("1300", window.innerWidth - 200);
    }

    // open the window catching the windowHandle and detect when it is deceased
    let windowHandle = window.open(propmixUrl, "mueller-propmix", windowFeatures);
    timer.current = setInterval(hidePropmix, 1000);
    // if we need to make the form non-editable... uncomment the next line
    formStatusChange(form.title, "openedComps", form.id);
    propmixVisibleSet(true);
    windowHandleSet(windowHandle);
  }

  function hidePropmix() {
    let handle = propMixWindowHandle.current;
    if (!handle || handle.closed) {
      clearInterval(timer.current);
      timer.current = 0;
      windowHandleSet(null);
      makeToast(AfterPropmixClosed, "success");
      formStatusChange(form.title, "closedComps", form.id);
      reloadFrameSet(true);
      propmixVisibleSet(false);
    }
  }

  // Collateral Analytics - SSO Integration using the C/A website
  // -------------------------------------------------------------------------------------------
  function showCollateralAnalyticsSso(e) {
    e.preventDefault();
    if (controlNumber === 0) return;
    if (!fetchingCollateralAnalyticsSsoParams
      || !comparable.controlNumber
      || comparable.controlNumber !== controlNumber) {
      fetchingCollateralAnalyticsSsoParamsSet(true);
      generateSsoParameters(controlNumber,
        (caSsoParameters) => {
          showCollateralAnalyticsSsoWindow(caSsoParameters);
          fetchingCollateralAnalyticsSsoParamsSet(false);
        }, (e) => {
          makeToast(e, "error");
          fetchingCollateralAnalyticsSsoParamsSet(false);
        }, mounted);
    }
    startSignalRConnection();
  }

  function showCollateralAnalyticsSsoWindow(caSsoParameters) {
    let windowFeatures = "width=1300,height=768,scrollbars=yes,resizable=yes,top=100,left=100";
    if (window.innerHeight < 768 && window.innerHeight > 200) {
      windowFeatures = windowFeatures.replace("768", window.innerHeight - 200);
    }
    if (window.innerWidth < 1300 && window.innerWidth > 200) {
      windowFeatures = windowFeatures.replace("1300", window.innerWidth - 200);
    }

    // open the window catching the windowHandle and detect when it is deceased
    let windowHandle = window.open(`${caSsoParameters.ssoSignOnUrl}?${caSsoParameters.ssoSignOnUrlQuerystring}`, "mueller-collateral-analytics-sso", windowFeatures);
    caSsoWindowHandleSet(windowHandle);
    caTimer.current = setInterval(hideCollateralAnalyticsSso, 1000);
    // if we need to make the form non-editable... uncomment the next line
    formStatusChange(form.title, "openedComps", form.id);
    collateralAnalyticsSsoVisibleSet(true);
  }

  function hideCollateralAnalyticsSso() {
    let handle = caSsoWindowHandle.current;
    if (!handle || handle.closed) {
      formStatusChange(form.title, "closedComps", form.id);
      clearInterval(caTimer.current);
      caTimer.current = 0;
      caSsoWindowHandleSet(null);
      reloadFrameSet(true);
      collateralAnalyticsSsoVisibleSet(false);
      makeToast(AfterCollateralAnalyticsSsoClosed, "success");
    }
  }

  // Import and Upload code
  // -------------------------------------------------------------------------------------------
  function setFile(currentlyUploadingFile) {
    currentlyUploadingFileSet(currentlyUploadingFile);
  }

  function startUploadingToBrowser(file) {
    const fileId = Date.now(); //wanted to use guids but theres no official support for guids in javascript :(
    currentlyUploadingFileIdSet(fileId);
    setFile(file);
    showConfirmDialog();
  }

  function startUploadingToServer() {
    importMismo(controlNumber, currentlyUploadingFile, serverUploadFinished);
    currentlyUploadingFileIdSet(null);
    uploadingSet(true);
  }

  function serverUploadFinished(data) {
    currentlyUploadingFileIdSet(null);
    currentlyUploadingFileSet(null);
    reloadFrameSet(true);
    uploadingSet(false);
    if (data.error) {
      makeToast(data.errorMessages[0] || ImportMismoToastError, "error");
    } else {
      makeToast(data.message || ImportMismoToastSuccess, "success");
    }
    formStatusChange(form.title, "closedComps", form.id);
    formStatusChange(form.title, "savedSuccess", form.id);
    formStatusChange(form.title, "clean", form.id);
    hideConfirmDialog();
  }

  function showConfirmDialog() {
    confirmIsVisibleSet(true);
    uploadingSet(false);
  }

  function hideConfirmDialog() {
    confirmIsVisibleSet(false);
    uploadingSet(false);
  }

  function confirmHandler() {
    startUploadingToServer(currentlyUploadingFileId);
  }

  function render() {
    const confirmMethods = [];
    if (uploading) {
      confirmMethods.push(<Button key="close" variant="text" color="secondary" onClick={hideConfirmDialog}>Close</Button>);
    } else {
      confirmMethods.push(<Button key="no" variant="text" color="secondary" onClick={hideConfirmDialog}>No</Button>);
      confirmMethods.push(<Button key="yes" onClick={confirmHandler}>Yes</Button>);
    }

    return (
      <div className="case-header comp-search">
        <div className="comp-search-header">
          <AppInsightsTracker
            formId={formId}
            formStatus={formStatus}
            controlNumber={controlNumber}
            location={location}
          />
          {
            form.compSearchForm.collateralAnalyticsSsoEnabled &&
            <Button
              id={formId + "_SearchCollateralAnalyticsSso"}
              variant="text"
             
              endIcon={collateralAnalyticsSsoIcon}
              disabled={collateralAnalyticsSsoVisible}
              onClick={showCollateralAnalyticsSso}
              style={{marginRight: "15px"}}>
              {fetchingCollateralAnalyticsSsoParams ? CollateralAnalyticsSsoStartupText
                : collateralAnalyticsSsoVisible ? CollateralAnalyticsSsoOpenText
                  : PrimarySearchButtonText}
            </Button>
          }
          {
            form.compSearchForm.propMixEnabled &&
            <Button
              id={formId + "_SearchPropmix"}
              variant="text"
             
              disabled={propmixVisible}
              onClick={showPropmix}
              style={{marginRight: "15px"}}>
              {fetchingPropmixSsoUrl ? PropmixStartupText
                : propmixVisible ? PropmixOpenText
                  : form.compSearchForm.collateralAnalyticsSsoEnabled ? SecondarySearchButtonText
                    : PrimarySearchButtonText }
            </Button>
          }
          {
            caVisible &&
            <Popout
              url={`${form.compSearchForm.collateralURI}&SSO=${token}`} // `
              options={{alwaysRaised: true, height: "768px", width: "1024px", resizable: true}}
              title="Collateral Connect"
              onClosing={hideCaSearch}>
              <div/>
            </Popout>
          }
          {
            !form.compSearchForm.collateralAnalyticsSsoEnabled &&
            <Button
              id={formId + "_CaSearchComps"}
              variant="text"
             
              onClick={showCaSearch}
              style={{marginRight: "15px"}}>
              {SecondarySearchButtonText}
            </Button>
          }
          {
            allowMismoImport &&
            <FileUpload
              accept=".xml"
              allowDuplicates={true}
              id="importFileInput"
              label={ImportMismoText}
              onLoadStart={setFile}
              onLoad={startUploadingToBrowser}
              onChange={null}
              className="file-inputs__upload-form__file-upload"
              name="file"
              primary
              icon={false}
            />
          }
        </div>
        {
          confirmIsVisible &&
          <Dialog
            id={"confirm-dialog"}
            open={confirmIsVisible}
            onClose={hideConfirmDialog}
            sx={{ '& .MuiDialog-paper': { width: 400 } }}
          >
            <DialogTitle>{ImportMismoText}</DialogTitle>
            <DialogContent>
              <div>
                {!uploading && <p>{ImportMismoWarning}</p>}
                {!uploading && <p>{ImportMismoQuestion}</p>}
                {uploading && <p>{ImportMismoWorking}</p>}
                {uploading && <MSpinner/>}
              </div>
            </DialogContent>
            <DialogActions>
              {uploading ? (
                <Button color="secondary" onClick={hideConfirmDialog}>Close</Button>
              ) : (
                <>
                  <Button color="secondary" onClick={hideConfirmDialog}>No</Button>
                  <Button onClick={confirmHandler}>Yes</Button>
                </>
              )}
            </DialogActions>
          </Dialog>
        }
        {
          !reloadFrame && form && // don't show if form is not set
          <ComparableGrid
            formStatusChange={formStatusChange}
            formTitle={form.title}
            formId={form.id}
            controlNumber={controlNumber}
            formStatus={form && form.formStatus}
            onPhotoView={onPhotoView}
            onFormSave={onFormSave}
          />
        }
      </div>
    );
  }

  return render();
};

CompSearch.propTypes = {
  form: PropTypes.object.isRequired,
  formId: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
  userEmail: PropTypes.string.isRequired,
  allowMismoImport: PropTypes.bool,

  caseHeader: PropTypes.object.isRequired,
  comparable: PropTypes.object.isRequired,

  formStatusChange: PropTypes.func.isRequired,
  formStatus: PropTypes.string,
  controlNumber: PropTypes.string.isRequired,

  importMismo: PropTypes.func,
  makeToast: PropTypes.func.isRequired,
  onPhotoView: PropTypes.func.isRequired,
  onFormSave: PropTypes.func.isRequired,
  signalrToken: PropTypes.string,
};

const mapStateToProps = (state) => ({
  signalrToken: state.user.profile.token,
});

const mapDispatchToProps = (dispatch) => ({
  initSignalR(signalrConnectionHub) {
    return dispatch(signalrConnectionHub);
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(CompSearch);
